import {
  LOADING_STATUS,
  USER_LOGOUT,
  API_LOADED_PREFIX,
} from '../types';

const defaultState = {
  loading: {
    status: 'loading',
    api: {},
  },
};

const loading = (state = defaultState.loading, action) => {
  if (action.type.indexOf(API_LOADED_PREFIX) !== -1) {
    const api = state.api;
    const key = action.type.replace(API_LOADED_PREFIX, '').toLowerCase();
    api[key] = true;
    return Object.assign({}, state, {
      api,
    });
  }
  switch (action.type) {
    case LOADING_STATUS:
      return Object.assign({}, state, {
        status: action.status,
      });

    case USER_LOGOUT:
      return Object.assign({}, defaultState.loading);

    default:
      return state;
  }
};

export default loading;



// WEBPACK FOOTER //
// ./src/state/reducers/loading.js